import { useEffect, useMemo, useState } from "react";
import QRCode from "qrcode";
import type { ProductRuntime } from "@/services/productRuntime";
import { analytics } from "@/services/analytics";
import { l, LImg } from "./assets";
import "./style.css";
type C = { androidUrl: string; iosUrl: string };
export default function Lolita({ product }: { product: ProductRuntime }) {
  const ch = useMemo(
      () => new URLSearchParams(location.search).get("channel") || "direct",
      [],
    ),
    [c, setC] = useState<C | null>(null),
    [qr, setQr] = useState("");
  useEffect(() => {
    document.title = "萝莉岛官方下载";
    analytics.report("landing_view", {
      metadata: {
        product: product.slug,
        productId: product.id,
        channel: ch,
        landingDevice: /iPhone|iPad/.test(navigator.userAgent)
          ? "ios"
          : /Android/.test(navigator.userAgent)
            ? "android"
            : "pc",
      },
    });
    const f = async (x: string) => {
      const r = await fetch(
        `/vdo-api/v1/products/${product.slug}/channels/${x}/config?_=${Date.now()}`,
        { cache: "no-store" },
      );
      if (!r.ok) throw 0;
      return (await r.json()).data;
    };
    f(ch)
      .catch(() => f("direct"))
      .then(setC);
    QRCode.toDataURL(location.href, { width: 180 }).then(setQr);
  }, [ch, product]);
  const dl = () => {
    if (!c) return;
    const ios = /iPhone|iPad/.test(navigator.userAgent);
    analytics.report("app_download_click", {
      metadata: {
        product: product.slug,
        productId: product.id,
        channel: ch,
        platform: ios ? "ios" : "android",
      },
    });
    location.href = ios ? c.iosUrl : c.androidUrl;
  };
  return (
    <main className="lol">
      <section className="lol-mobile">
        <header>
          <LImg id={l.logo} />
          <b>萝莉岛</b>
          <nav>
            <a href="https://t.me/dahe68868">商务</a>
            <a href="https://t.me/dahe68868">客服</a>
          </nav>
        </header>
        <div className="lol-slides">
          <article className="lol-s1">
            <LImg id={l.bg} className="cover" />
            <LImg id={l.rays} className="rays" />
            <LImg id={l.arch} className="arch" />
            <LImg id={l.figure} className="figure" />
            <LImg id={l.title} className="title" />
          </article>
          <article>
            <LImg id={l.bg23} className="cover" />
            <LImg id={l.s2title} className="title" />
            <LImg id={l.s2figure} className="figure" />
            <LImg id={l.s2cards} className="cards" />
          </article>
          <article>
            <LImg id={l.bg23} className="cover" />
            <LImg id={l.s3title} className="title" />
            <LImg id={l.s3figure} className="figure" />
            <LImg id={l.s3cards} className="cards" />
          </article>
          <article className="gallery">
            {l.g.map((x) => (
              <LImg id={x} key={x} />
            ))}
          </article>
        </div>
      <button
        className="lol-download"
        onClick={dl}
        disabled={!c}
        aria-label={/iPhone|iPad/.test(navigator.userAgent) ? "iOS安装" : "安卓下载"}
      >
        <LImg id={l.apple} />
        <span>
          <b>
            {c
              ? /iPhone|iPad/.test(navigator.userAgent)
                ? "iOS 安装"
                : "立即下载"
              : "正在获取下载地址"}
          </b>
          <small>
            {/iPhone|iPad/.test(navigator.userAgent)
              ? "安装萝莉岛到桌面"
              : "萝莉岛官方正版 APK"}
          </small>
        </span>
        </button>
      </section>
      <section className="lol-pc">
        <LImg id={l.pcBg} className="cover" />
        <header>
          <LImg id={l.pcLogo} />
          <span>商务合作　 在线客服</span>
        </header>
        <LImg id={l.pcTitle} className="pc-title" />
        <LImg id={l.pcFigure} className="pc-figure" />
        <LImg id={l.pcGallery} className="pc-gallery" />
        {qr && (
          <div className="lol-qr">
            <img src={qr} />
            <b>扫码下载萝莉岛</b>
          </div>
        )}
      </section>
    </main>
  );
}
